/**
 * EUR-цена для не-украинских посетителей (2026-08-27).
 *
 * Встроенная мультивалютность Shopify Markets тут недоступна: смена валюты
 * требует Shopify Payments (не работает в Украине), а маркет "Europe Union"
 * вообще без web presence — Shopify не может определить визитора как
 * "не Украина" даже с ?country_code=. Подробности — Shopify - GENERAL/CLAUDE.md.
 *
 * Поэтому переключение полностью ручное: виджет в футере/шапке
 * (currency-toggle.liquid) ставит cookie mmsw_currency=EUR/UAH и
 * перезагружает страницу. Liquid всегда рендерит UAH — безопасный дефолт
 * для ботов/SEO/без JS.
 *
 * Конвенция (2026-08-27, ред.2): любой элемент, который должен уметь
 * показывать EUR, помечается атрибутом data-eur-amount="<raw-копейки>" —
 * этот скрипт на загрузке подменяет его innerHTML на отформатированный EUR,
 * если валюта переключена. Работает универсально — и для price.liquid
 * (.js-value), и для простых .theme-money в корзине (cart-item.liquid,
 * cart-drawer.liquid), без привязки к конкретной структуре разметки.
 * Следит за динамически подгружаемыми блоками (аякс-корзина, quick view,
 * бесконечный скролл коллекции) через MutationObserver.
 *
 * Курс — window.theme.settings.eurRate (raw число EUR за 1 UAH), обновляется
 * раз в сутки cron-скриптом eur_rate_sync.py в shop.metafields.custom.eur_rate.
 *
 * Смена варианта товара (цвет/размер) на странице товара обрабатывается ОТДЕЛЬНО
 * в variant-picker.js (currentCurrency()/formatPriceHtml() там же) — эта секция
 * переписывает .js-value напрямую в обход обычного рендера, так что данный
 * скрипт её не перехватывает.
 *
 * Автоопределение (2026-08-27, ред.3): при ПЕРВОМ визите (нет cookie
 * mmsw_currency вообще) делаем клиентский geo-IP запрос (ipwho.is —
 * бесплатно, без ключа, без лимита, CORS открыт) и, если страна не 'UA',
 * сами ставим EUR и применяем его без перезагрузки (applyAll() +
 * событие mmsw:currency-changed для синхронизации кнопки-переключателя).
 * Результат кэшируется в том же cookie на год — гео-запрос делается не
 * чаще одного раза на посетителя. Если у визитора уже ЕСТЬ cookie (свой
 * выбор или предыдущий авто-детект) — геолокацию не трогаем вообще.
 */
(function () {
  var COOKIE_NAME = 'mmsw_currency';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value) {
    var oneYear = 60 * 60 * 24 * 365;
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + oneYear + '; SameSite=Lax';
  }

  function eurAllowed() {
    return !!(window.theme && window.theme.settings && window.theme.settings.eurAllowed && window.theme.settings.eurRate > 0);
  }

  function currentCurrency() {
    return eurAllowed() && getCookie(COOKIE_NAME) === 'EUR' ? 'EUR' : 'UAH';
  }

  var GEO_API_URL = 'https://ipwho.is/';
  var GEO_TIMEOUT_MS = 3000;

  function autoDetectCurrency() {
    if (!eurAllowed()) return;
    if (getCookie(COOKIE_NAME) !== null) return; // уже есть выбор — ручной или предыдущий авто-детект, не трогаем

    // SYeN 2026-10-05 - UAH по языку браузера: украинский/русский в языках браузера — гривна сразу, без гео-запроса
    var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    for (var i = 0; i < langs.length; i++) {
      if (/^(uk|ru)\b/i.test(langs[i])) {
        setCookie(COOKIE_NAME, 'UAH');
        return;
      }
    }

    var controller = ('AbortController' in window) ? new AbortController() : null;
    var timeoutId = controller ? setTimeout(function () { controller.abort(); }, GEO_TIMEOUT_MS) : null;

    fetch(GEO_API_URL, { signal: controller ? controller.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (timeoutId) clearTimeout(timeoutId);
        if (getCookie(COOKIE_NAME) !== null) return; // визитор успел кликнуть переключатель, пока запрос летел

        var countryCode = data && data.success !== false && data.country_code;
        var detected = (countryCode && countryCode !== 'UA') ? 'EUR' : 'UAH';
        setCookie(COOKIE_NAME, detected);

        if (detected === 'EUR') {
          applyAll();
          window.dispatchEvent(new CustomEvent('mmsw:currency-changed', { detail: { currency: detected } }));
        }
      })
      .catch(function () {
        if (timeoutId) clearTimeout(timeoutId);
        // гео-запрос не удался (сеть/таймаут/блокировщик) — cookie НЕ ставим,
        // чтобы попробовать снова на следующей странице, а не залипнуть
        // в UAH навсегда из-за одного сбоя
      });
  }

  function formatEur(amountCents) {
    // Raw-копейки/центы (190000 = 1900.00 UAH, проверено эмпирически
    // 2026-08-27 — Liquid {{ price }} без money-фильтра, item.final_price
    // и т.п. отдают именно это, а не десятичные major units).
    var rate = window.theme.settings.eurRate;
    var value = (parseFloat(amountCents) / 100) * rate;
    if (isNaN(value)) return '';
    return value.toFixed(2) + ' €';
  }

  function applyToElement(el) {
    if (!eurAllowed() || currentCurrency() !== 'EUR') return;
    var raw = el.getAttribute('data-eur-amount');
    if (raw === null) return;
    el.innerHTML = formatEur(raw);

    var priceContainer = el.closest('.price');
    if (priceContainer) {
      var note = priceContainer.querySelector('.price__eur-note');
      if (note) note.hidden = false;
    }
  }

  function applyFreeShippingBar(root) {
    // Порог "від N для безкоштовної доставки" (free-shipping-bar.liquid) для
    // EUR — НЕ курсовая конвертация UAH-порога, а отдельное правило мерчанта
    // (Theme settings → free_shipping_amounts, строка "EUR:20000" = від 200
    // EUR), см. CLAUDE.md. Поэтому пересчитываем прогресс/текст целиком,
    // а не просто подменяем число как в applyToElement.
    if (currentCurrency() !== 'EUR') return;
    (root || document).querySelectorAll('.free-shipping-bar[data-free-shipping-eur-amount]').forEach(function (bar) {
      var eurThresholdCents = parseFloat(bar.getAttribute('data-free-shipping-eur-amount'));
      var cartTotalUahCents = parseFloat(bar.getAttribute('data-free-shipping-current-cart'));
      var rate = window.theme.settings.eurRate;
      if (isNaN(eurThresholdCents) || isNaN(cartTotalUahCents) || !rate) return;

      var cartTotalEur = (cartTotalUahCents / 100) * rate;
      var eurThreshold = eurThresholdCents / 100;
      var progress = Math.min(1, cartTotalEur / eurThreshold);
      var deficitEur = Math.max(0, eurThreshold - cartTotalEur);

      bar.style.setProperty('--free-shipping-progress', progress);
      bar.setAttribute('data-free-shipping-progress', progress >= 1 ? '1' : String(progress));

      var diffEl = bar.querySelector('.free-shipping-bar__diff-amount');
      if (diffEl) diffEl.textContent = deficitEur.toFixed(2) + ' €';
    });
  }

  function syncToggleButtons(root) {
    var current = currentCurrency();
    (root || document).querySelectorAll('[data-currency-toggle] [data-currency]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.currency === current ? 'true' : 'false');
    });
  }

  function wireCurrencyToggles(root) {
    // Клик-обработчики — тут, а не inline <script> в currency-toggle.liquid
    // (см. комментарий в этом файле): тот снипет рендерится и внутри
    // <script type="text/template"> мобильного меню (header.liquid), где
    // собственный </script> обрывал шаблон. dataset.mmswWired — чтобы не
    // навешивать обработчик повторно на уже подключенные кнопки при
    // пересканировании (MutationObserver может звать это много раз).
    (root || document).querySelectorAll('[data-currency-toggle] [data-currency]').forEach(function (btn) {
      if (btn.dataset.mmswWired) return;
      btn.dataset.mmswWired = '1';
      btn.addEventListener('click', function () {
        window.MMSW.currency.set(btn.dataset.currency);
      });
    });
    syncToggleButtons(root);
  }

  function applyAll(root) {
    (root || document).querySelectorAll('[data-eur-amount]').forEach(applyToElement);
    applyFreeShippingBar(root);
    wireCurrencyToggles(root);
  }

  window.MMSW = window.MMSW || {};
  window.MMSW.currency = {
    get: currentCurrency,
    set: function (value) {
      setCookie(COOKIE_NAME, value);
      window.location.reload();
    },
    formatEur: formatEur,
    applyToElement: applyToElement
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (!eurAllowed()) {
      applyAll();
      return; // нечего наблюдать, если EUR вообще недоступен на этой странице
    }

    // Тема мержит обновления корзины/секций через свой data-merge /
    // data-merge-attributes (main.js theme.mergeNodes) — он либо точечно
    // делает el.innerHTML = ... на существующем узле, либо targetEl.setAttribute(...)
    // на существующем узле БЕЗ вставки нового. Первое даёт childList-мутацию
    // на потомке .free-shipping-bar (не на нём самом — root-относительный
    // querySelectorAll её не найдёт, поэтому просто пересканируем весь
    // документ), второе — attributes-мутацию на самом .free-shipping-bar
    // (перезаписывает наш --free-shipping-progress/data-free-shipping-progress
    // свежими UAH-значениями с сервера). Наблюдаем оба случая.
    //
    // ВАЖНО (2026-08-27, найдено эмпирически — вешало вкладку насмерть):
    // applyFreeShippingBar САМА пишет именно эти attributeFilter-атрибуты
    // (style/data-free-shipping-progress) — без disconnect/observe вокруг
    // applyAll() это самозацикливает MutationObserver (наша же запись
    // порождает мутацию, которая вызывает applyAll(), которая снова
    // пишет атрибут, ...) и синхронно вешает JS-поток. См. CLAUDE.md.
    var observer = new MutationObserver(function (mutations) {
      var needsRescan = false;
      for (var i = 0; i < mutations.length; i += 1) {
        var m = mutations[i];
        if (m.type === 'childList' && (m.addedNodes.length > 0)) {
          needsRescan = true;
          break;
        }
        if (m.type === 'attributes' && m.target.nodeType === 1 && m.target.matches && m.target.matches('.free-shipping-bar')) {
          needsRescan = true;
          break;
        }
      }
      if (!needsRescan) return;

      observer.disconnect();
      applyAll();
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'data-free-shipping-progress', 'data-free-shipping-current-cart', 'data-free-shipping-eur-amount']
      });
    });

    applyAll();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'data-free-shipping-progress', 'data-free-shipping-current-cart', 'data-free-shipping-eur-amount']
    });

    autoDetectCurrency();
  });
})();
